import './prelude';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import createApolloClient from './createApolloClient';
import runtime from './runtime';
import createI18Instance from './utilities/createI18nInstance';

const { i18n } = createI18Instance(runtime.initialLanguage.internalCode, runtime.languageCaches);

const element = (
    <BrowserRouter basename={runtime.router.pathname}>
        <App createApolloClient={createApolloClient} i18n={i18n} runtime={runtime} />
    </BrowserRouter>
);

const container = document.getElementById('root');

createRoot(container).render(element);
